import {
  InfoModule,
  createInfoServices
} from "./chunk-MU4RMLXT.mjs";
import "./chunk-O6L2WK4J.mjs";
export {
  InfoModule,
  createInfoServices
};
